import { useContext } from 'react';
import { Toggle } from '../../types/toggles';
import { FeatureToggleContext } from '../contexts/FeatureToggleContext';
import { Loadable } from '../../types/commonTypes';

export const useFeatureToggles = (): Loadable<Toggle[]> => {
  const context = useContext(FeatureToggleContext);

  return context;
};
